import React, { ReactNode } from "react";

import { Typography } from "@material-ui/core";

import { useProjectSelectOptionStyles } from "./useProjectSelectOptionStyles";

import { ProjectSelectOptionType } from "../helpers";

interface IProps {
  label: string;
  type: ProjectSelectOptionType;
  icon: ReactNode;
  selected: boolean;
}

const ProjectSelectOption: React.FC<IProps> = props => {
  const { label, type, icon, selected } = props;

  const classes = useProjectSelectOptionStyles({ type });

  return (
    <div className={classes.container}>
      <span className={classes.icon}>{icon}</span>

      <Typography
        variant="caption"
        className={classes.label}
        title={label}
        noWrap
      >
        {selected && <span className={classes.currentLabel}>[Current]</span>}
        {label}
      </Typography>
    </div>
  );
};

export default React.memo(ProjectSelectOption);
